export enum CameraErrors {
  NotAllowed = 'NotAllowedError : Permission denied',
  NotFound = 'NotFoundError : Requested device not found'
}
